import IconButton from '../../../../../components/UI/Button/IconButton'
interface Props {
  title?: string
  isEdit?: boolean
  isSearch?: boolean
  isActive?: boolean
  handleBack?: () => void
  handleSearch?: () => void
}

const HeaderTitle = ({
  title,
  isEdit = false,
  handleBack,
  isSearch = false,
  handleSearch,
  isActive = false,
}: Props) => {
  return (
    <div className='mb-0 d-flex justify-content-between'>
      <h4>{title}</h4>
      {isSearch && (
        <div className='d-flex align-items-center mb-4'>
          <IconButton
            onClick={handleSearch}
            color='#283897'
            margin='me-2'
            classNameB='svg-icon-3x'
            active={isActive}
            path={
              isActive
                ? '/media/icons/duotune/technology/QRreader.svg'
                : '/media/icons/duotune/technology/QRreader-block.svg'
            }
          />
          {isActive && (
            <p className='mb-0 ' style={{fontSize: '12px', color: '2A295C'}}>
              Scanear usuario
            </p>
          )}
        </div>
      )}
      {isEdit && (
        <IconButton
          onClick={handleBack}
          color='#283897'
          path='/media/icons/duotune/arrows/arr015.svg'
        />
      )}
    </div>
  )
}

export default HeaderTitle
